import React from 'react';
import { Phone, MessageCircle, Star } from 'lucide-react';
interface ClientCardProps {
  id: number;
  name: string;
  budget: string;
  type: 'BUY' | 'RENT';
  initials: string;
  onClick?: (id: number) => void;
}
export function ClientCard({
  id,
  name,
  budget,
  type,
  initials,
  onClick
}: ClientCardProps) {
  return <div className="bg-white p-4 border-b border-gray-100 last:border-0 cursor-pointer hover:bg-neutral-bg transition-colors" onClick={() => onClick && onClick(id)} data-id="element-53">
      <div className="flex items-start gap-4" data-id="element-54">
        {/* Avatar */}
        <div className="h-12 w-12 rounded-full bg-gray-200 flex items-center justify-center flex-shrink-0" data-id="element-55">
          <span className="text-gray-500 font-semibold text-lg" data-id="element-56">
            {initials}
          </span>
        </div>

        {/* Content */}
        <div className="flex-1 min-w-0" data-id="element-57">
          {/* Rating */}
          <div className="flex gap-0.5 mb-1" data-id="element-58">
            {[1, 2, 3].map(i => <Star key={i} className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-59" />)}
          </div>

          {/* Name */}
          <h3 className="font-medium text-neutral-text truncate mb-1" data-id="element-60">
            {name}
          </h3>

          {/* Details */}
          <div className="flex items-center gap-2 flex-wrap" data-id="element-61">
            <span className="text-sm text-gray-500" data-id="element-62">{budget}</span>
            <span className="bg-accent/10 text-accent-dark text-[10px] font-bold px-2 py-0.5 rounded" data-id="element-63">
              {type}
            </span>
          </div>
        </div>

        {/* Actions */}
        <div className="flex gap-4 items-center pt-2" onClick={e => e.stopPropagation()} data-id="element-64">
          <button className="text-gray-400 hover:text-secondary transition-colors" data-id="element-65">
            <Phone className="w-5 h-5" data-id="element-66" />
          </button>
          <button className="text-gray-400 hover:text-green-600 transition-colors" data-id="element-67">
            <MessageCircle className="w-5 h-5" data-id="element-68" />
          </button>
        </div>
      </div>
    </div>;
}